<template>
  <div :style="themeStyles">
    <div class="flex justify-around">
      <div>
        <div class="text-xl text-color">
          Male
        </div>
        <div class="text-2xl text-color">
          {{ series[1].toLocaleString() }}
        </div>
      </div>
      <div>
        <div class="text-xl text-color opacity-75">
          Female
        </div>
        <div class="text-2xl text-color opacity-75">
          {{ series[0].toLocaleString() }}
        </div>
      </div>
    </div>
    <apexchart
      type="pie"
      width="100%"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
export default {
  data() {
    return {
      series: [50, 50],
      boys: 0,
      girls: 0,
      primaryColor: "",
      lighterPrimaryColor: "",
      chartOptions: {
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -25
            }
          }
        },
        colors: ["#f687b3", "#63b3ed"],
        labels: ["Female", "Male"],
        toolbar: {
          show: false
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "16px",
            //fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: "bold"
          }
        },
        responsive: [
          {
            options: {
              chart: {},
              legend: {
                //position: "bottom"
              }
            }
          }
        ]
      }
    };
  },
  props: {
    location: {
      type: Object,
      required: true
    },
    radius: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  created() {
    this.setThemeColors();
    this.updateGender();
  },
  methods: {
    updateGender() {
      this.$http
        .post(
          "/reach-estimates/genders",
          {
            latitude: this.location.lat,
            longitude: this.location.lng,
            /* eslint-disable */
        targeting_radius: this.radius
            /* eslint-enable */
          },
          { retry: 5, retryDelay: 250 }
        )
        .then(response => {
          this.series = [response.data.female, response.data.male];
          this.$emit("loaded");
        })
        .catch(error => {
          console.log(error);
        });
    },
    setThemeColors() {
      this.lighterPrimaryColor = this.color + "99"; //Apply 50% opacity to the color hex code
      this.primaryColor = this.color;
      this.chartOptions.colors[0] = this.lighterPrimaryColor;
      this.chartOptions.colors[1] = this.primaryColor;
    }
  },
  computed: {
    themeStyles() {
      return {
        "--color": this.primaryColor
      };
    }
  }
};
</script>

<style>
.text-color {
  color: var(--color);
}
</style>
